import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { useEffect, useState } from "react";
import { authActions, flowActions } from "redux/Ldb/actions";

const useGetUserFlowMode = () => {
    const dispatch = useAppDispatch();
    const [mode, setMode] = useState<string>("");
    const [userProfile, setUserProfile] = useState<{ [key: string]: any }>({});

    const { fetchUserProfileSuccess } = useAppSelector((state) => state.auth);
    const { flowModeSuccess } = useAppSelector((state) => state.flow);

    useEffect(() => {
        dispatch(authActions.getLdbProfile());
    }, [dispatch]);

    useEffect(() => {
        if (Boolean(flowModeSuccess)) {
            dispatch(authActions.getLdbProfile());
            dispatch(flowActions.resetFlowMode());
        }
    }, [dispatch, flowModeSuccess]);

    useEffect(() => {
        if (Boolean(fetchUserProfileSuccess)) {
            setMode(fetchUserProfileSuccess?.profile?.flowMode);
            setUserProfile(fetchUserProfileSuccess);
        }
    }, [fetchUserProfileSuccess]);

    return {
        mode,
        userProfile,
    };
};

export default useGetUserFlowMode;
